const data = [
  {
    id: 1,
    image: require("./works-img/work-1.jpg"),
    title: "Chat App",
    description: "React, SCSS, Firebase",
    github: "https://github.com/rootfellen/kuku-chat",
    live: "https://kuku-chat.netlify.app/",
    idea: "Simple dice game for kids, where person should get all the same dices in a short period of time with a smallest amount of rolls",
    features: "Reusable components, React Hooks, working with localStorage",
  },
  {
    id: 2,
    image: require("./works-img/work-2.jpg"),
    title: "JOAT App",
    description: "React, Styled Components ",
    github: "https://github.com/rootfellen/joat-app",
    live: "https://joat-app.netlify.app/",
    idea: "All in one, including: Password Generator, PDF Generator, QR Code Generator, UI Framework, RegEx Helper, Color Generator, Vote Creator Utilities.",
    features:
      "Dark Mode (handled by React Context Hook, triggered with dispatch + reducers, Upload avatar, Can filter tables, Flexible data, can be fetched from API / Database in future, Reusable components, New features to be added soon..",
  },
  {
    id: 3,
    image: require("./works-img/work-3.jpg"),
    title: "Easy Route App",
    description: "React, React Hooks, TomTom API",
    github: "https://github.com/rootfellen/easy-route-app/tree/main",
    live: "https://rootfellen.github.io/easy-route-app/",
    idea: "This app is calculating the shortest distance through all location markers on the map by using Tom Tom SDK Matrix Routing.",
    features:
      "displayed closed roads displayed traffic on the roads displayed accidents on the roads using current location with ability to add yours as per your coordinates. The final route is calculated using the “Routing API” which by default will do a “car”  route.",
  },
  {
    id: 4,
    image: require("./works-img/work-4.png"),
    title: "Safe Banking React Website",
    description: "React, Styled Components, React-Scroll",
    github: "https://github.com/rootfellen/safe-banking-website",
    live: "https://rootfellen.github.io/safe-banking-website/",
    idea: "React based fully responsive website for virtual banking platform. Created with React Components, Styled-Components, React-Scroll, React Hooks.",
    features:
      "I've practiced using react-scroll as it was a new feature for me to make a scroll actions smoooth, and styled-components as well.",
  },
  {
    id: 5,
    image: require("./works-img/work-5.png"),
    title: "Quizzzle App",
    description:
      "React, Open Trivia DP API, RapidAPI Famous Quotes, React Hooks",
    github: "https://github.com/rootfellen/quizzle",
    live: "https://quizzzle.netlify.app/",
    idea: "Quiz App with 6 random questions on random topics. Intro message with famous random quote.",
    features:
      "I've practiced fetching data from REST API's, working with controlled radio typed inputs, conditional rendering. Next features to be added: Questions topic, difficulty, amount of questions to be selected on intro",
  },
  {
    id: 6,
    image: require("./works-img/work-6.png"),
    title: "Fourcast Weather App",
    description:
      "React, Weather RapidAPI, React Accessible Accordion, React Select Async Paginate",
    github: "https://github.com/rootfellen/fourcast-weather-app/tree/master",
    live: "https://fourcast.netlify.app/",
    idea: "Weather Forecast App to check the current and 7 days forecast weather in any city in the world",
    features:
      "Fetching data from RapidAPI Weather API, simple user friendly design, search input with smooth debounce.",
  },
  {
    id: 7,
    image: require("./works-img/work-7.jpg"),
    title: "Tenzies Game",
    description: "React, React Hooks, localStorage",
    github: "https://github.com/rootfellen/tenzies",
    live: "https://rootfellen.github.io/tenzies/",
    idea: "Simple dice game for kids, where person should get all the same dices in a short period of time with a smallest amount of rolls",
    features: "Reusable components, React Hooks, working with localStorage",
  },
  {
    id: 8,
    image: require("./works-img/work-8.jpg"),
    title: "React Admin Dashboard",
    description: "Material UI, React Context, Recharts, RRD, Reducer",
    github: "https://github.com/rootfellen/react-admin-panel/tree/master",
    live: "https://rootfellen.github.io/react-admin-panel/",
    idea: "Simple Admin Panel Template, made with React. Implemented design using SCSS and Material UI Icons, Tables from Material UI, Progress Bar from React-Circular-ProgressBar, Charts from Recharts",
    features:
      "Dark Mode (handled by React Context Hook, triggered with dispatch + reducers, Upload avatar, Can filter tables, Flexible data, can be fetched from API / Database in future, Reusable components, New features to be added soon..",
  },
  {
    id: 9,
    image: require("./works-img/work-empty.png"),
    title: "App Name",
    description:
      "Ad excepteur excepteur occaecat velit et do id culpa nostrud.",
    github: "https://github.com/rootfellen/",
    live: "https://rootfellen.netlify.app/",
    idea: "Laborum Lorem occaecat elit irure veniam cillum aute excepteur Lorem aute consequat.",
    features:
      "Eiusmod duis esse non ullamco nostrud aliqua nostrud ipsum labore dolor.Elit ea sint amet incididunt veniam deserunt mollit est.",
  },
  {
    id: 10,
    image: require("./works-img/work-empty.png"),
    title: "App Name",
    description:
      "Ad excepteur excepteur occaecat velit et do id culpa nostrud.",
    github: "https://github.com/rootfellen/",
    live: "https://rootfellen.netlify.app/",
    idea: "Laborum Lorem occaecat elit irure veniam cillum aute excepteur Lorem aute consequat.",
    features:
      "Eiusmod duis esse non ullamco nostrud aliqua nostrud ipsum labore dolor.Elit ea sint amet incididunt veniam deserunt mollit est.",
  },
  {
    id: 11,
    image: require("./works-img/work-empty.png"),
    title: "App Name",
    description:
      "Ad excepteur excepteur occaecat velit et do id culpa nostrud.",
    github: "https://github.com/rootfellen/",
    live: "https://rootfellen.netlify.app/",
    idea: "Laborum Lorem occaecat elit irure veniam cillum aute excepteur Lorem aute consequat.",
    features:
      "Eiusmod duis esse non ullamco nostrud aliqua nostrud ipsum labore dolor.Elit ea sint amet incididunt veniam deserunt mollit est.",
  },
  {
    id: 12,
    image: require("./works-img/work-empty.png"),
    title: "App Name",
    description:
      "Ad excepteur excepteur occaecat velit et do id culpa nostrud.",
    github: "https://github.com/rootfellen/",
    live: "https://rootfellen.netlify.app/",
    idea: "Laborum Lorem occaecat elit irure veniam cillum aute excepteur Lorem aute consequat.",
    features:
      "Eiusmod duis esse non ullamco nostrud aliqua nostrud ipsum labore dolor.Elit ea sint amet incididunt veniam deserunt mollit est.",
  },
];

export default data;
